import { useToggle } from "usehooks-ts";

import { SKSpinner } from "components/customElements/skSpinner";

export const TOOL_SHAREHOLDER_REGISTRY_NAME = "Shareholder Registry";
export const TOOL_SHAREHOLDER_REGISTRY_DESCRIPTION =
  "Institutional shareholder data, peer comparison and AI-powered registry analysis";

const ToolShareholderRegistry = () => {
  const [isLoading, toggleIsLoading] = useToggle(true);
  return (
    <div className="">
      {isLoading && (
        <div className="w-full flex justify-center">
          <SKSpinner />
        </div>
      )}
      <iframe
        src="https://registry.smartkarma.com/"
        onLoad={toggleIsLoading}
        onError={toggleIsLoading}
        frameBorder={0}
        className="w-full h-[600px] md:h-[160vh] border-0"
        allowFullScreen
        allow="clipboard-write"
      ></iframe>
    </div>
  );
};

export default ToolShareholderRegistry;
